export default __webpack_public_path__ + "static/media/tournamentLargeIcon.9e3eddff.svg";